var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      minWidth: 29
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.0002C0.5 6.26752 6.8651 0 14.7182 0C22.5708 0 28.9359 6.26752 28.9359 14.0002C28.9359 21.7325 22.5708 28 14.7182 28C6.8651 28 0.5 21.7325 0.5 14.0002ZM3.64849 14.5918H13.6607L10.7892 25.9345L25.8252 13.1778H15.4546L18.3252 1.97751L3.64849 14.5918ZM13.9479 13.1778H7.45212L15.778 6.00562L13.9479 13.1778ZM13.2653 21.9768L15.0953 14.5918H21.9505L13.2653 21.9768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.fdc84396d83d1dc02bbea7632e1fcbb0.svg";
export { ForwardRef as ReactComponent };